import { useEffect, useState } from "react";

export default function ModalEnvio({ n_solicitacao }: any) {

    const [progress, setProgress] = useState<number>(100); // Começa com 100%

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(prev => (prev > 0 ? prev - 1 : 0));
        }, 50); // 100 decrementos ao longo de 3 segundos

        return () => clearInterval(interval);
    }, []);

    return(
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(35, 54, 113, 0.9)',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
        }}>
            <div style={{ textAlign: 'center', width: '80%', maxWidth: '600px' }}>
                <h1>O Laboratório Químico agradece a sua solicitação!</h1>
                <h3>O ID da sua solicitação é {n_solicitacao}</h3>
                <h4>Você poderá ver o progresso na seção de acompanhamento</h4>
                <div style={{ 
                    width: '100%', 
                    height: '5px', 
                    backgroundColor: 'white', 
                    marginTop: '30px', 
                    borderRadius: '5px', 
                    overflow: 'hidden' 
                }}>
                    <div style={{ 
                        width: `${progress}%`, 
                        height: '100%', 
                        backgroundColor: 'green', 
                        transition: 'width 0.03s linear' 
                    }} />
                </div>
            </div>
        </div>
    )
}